import { memo, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ComponentLineButton } from "@components";
import { IExternalAuthState } from "@interfaces";
import liff from "@line/liff";
import { selectMerchant } from "@redux";
import CacheStore from "@Rocket-Innovation/components/store/CacheStore";
import { useHistory } from "react-router";

interface IProps {
    state: IExternalAuthState;
}

export const ModuleLine = memo((props: IProps) => {
    //props
    const isReady = CacheStore((state: any) => state.isReady);
    const { state } = props;
    const dispatch = useDispatch();
    const merchant = useSelector(selectMerchant);
    const signUpMethod = merchant?.signUpSettings?.signUpMethod;
    const history = useHistory();
    const isTechDomain = () => {
        const currentURL = window.location.href;
        return currentURL.includes(".app");
    };
    //redux page
    useEffect(() => {
        // if (!liff.isInClient()) {
        // }
        // dispatch(resetLineToken());
    }, []);
    const { lineIntegration } = useSelector(selectMerchant);
    const lineRedirectUrl = window.location.origin + "/";
    const handleLineLogin = useCallback(async () => {
        await null;
        try {
            // Focus here!
            // sessionStorage.setItem("LINE_LOGIN_SUCCESS", "true");
            // history.push("/");
            localStorage.setItem("LINE_LOGIN_PROCESS", "true");
            localStorage.setItem("LINE_LOGIN_SUCCESS", "true");
            sessionStorage.setItem("DISABLE_APP_ROUTE", "true");

            if (isReady) {
                liff.login();
            }
        } catch (err: any) {
            console.error(err);
            // alert(`Line Login catch: ${err}`);
        }
        // // Build query string.

        // const query = querystring.stringify({
        //     response_type: "code",
        //     client_id: lineIntegration?.lineLoginApi?.channelID || "",
        //     state: JSON.stringify(state),
        //     redirect_uri: lineRedirectUrl,
        // });

        // // Build the Line authorize URL.
        // const lineUrl = `${LINE_ACCESS_URL}/authorize?&bot_prompt=normal&scope=${LINE_SCOPE}&${query}`;

        // window.location.href = lineUrl;
        // // Redirect to external URL.
    }, [isReady]);

    return <ComponentLineButton onClick={handleLineLogin} />;
});
